import React from 'react';

import { IComponent } from '../../../typings/generic-component';
import { TennisSurface, TennisTournament } from '../../../typings/tennis';
import { makeClassNames } from '../../../utils/styles';
import { dateFormat } from '../../../utils/times';
import Cta from '../../atoms/cta/cta';
import Text from '../../atoms/text/text';

import './tennis-calendar-card.scss';

export interface ITennisCalendarCard extends IComponent {
  tournamentName: string;
  tournamentPlace: string;
  startDate: string;
  endDate: string;
  surface: TennisSurface;
  tournamentType: TennisTournament;
  href?: string;
  onClick?: () => void;
}

const classNames = () =>
  makeClassNames({
    tennisCalendarCard: 'tennis-calendar-card',
    dateImgContainer: 'date-img-container',
    date: 'date',
    img: 'img',
    logo: 'logo',
    info: 'info',
    surface: 'surface',
    tournament: 'tournament',
    tournamentPlace: 'tournament-place',
    screenReaderOnly: 'screen-reader-only',
    link: 'tennis-calendar-card__link',
  });

const cn = classNames();

const TennisCalendarCard = ({
  tournamentName,
  tournamentPlace,
  tournamentType,
  surface,
  startDate,
  endDate,
  href = '',
  trackingData = {},
  onClick,
}: ITennisCalendarCard) => {
  const cardContent = (
    <article className={cn.tennisCalendarCard} data-surface={surface}>
      <div className={cn.dateImgContainer}>
        <Text className={cn.date}>
          {dateFormat({ date: startDate, format: 'D MMM' })} - {dateFormat({ date: endDate, format: 'D MMM' })}
        </Text>
        <div className={cn.img}>
          <div className={cn.logo} data-type={tournamentType}>
            <span className={cn.screenReaderOnly}>
              {tournamentType
                .split('-')
                .map((item) => item[0].toUpperCase() + item.slice(1))
                .join(' ')}
            </span>
          </div>
        </div>
      </div>
      <div className={cn.info}>
        <Text className={cn.surface}>{surface}</Text>
        <Text className={cn.tournament}>{tournamentName}</Text>
        <Text fontSize="14" fontWeight="400" className={cn.tournamentPlace}>
          {tournamentPlace}
        </Text>
      </div>
    </article>
  );

  return href.length > 0 ? (
    <Cta href={href} className={cn.link} trackingData={trackingData} onClick={onClick}>
      {cardContent}
    </Cta>
  ) : (
    cardContent
  );
};

export default TennisCalendarCard;
